const Button = ({ height, children, onClick, className, px }) => {
	return (
		<button
			onClick={onClick}
			style={{ height }}
			className={`${className} ${
				px ?? 'px-[20px]'
			} relative inline-flex text-white justify-center items-center w-full overflow-hidden bg-[#E71CA5] rounded-full transition-all duration-500 ease-in-out hover:shadow-glow-pink hover:scale-[1.02] active:scale-95`}
		>
			<span>{children}</span>
		</button>
	);
};

export default Button;
